import axios from "axios";
import React, { useState } from "react";
import { WORKSHOP_ID } from "../../../constants";
import { toast } from "react-toastify";
import useThemeColors from "../../vehicle/ThemeColors";
import { useNavigate } from "react-router-dom";

interface IPROPS {
  closeModal: any;
  // refetch:any
  requestedId: any;
}

const ConfirmationModal: React.FC<IPROPS> = ({ closeModal, requestedId }) => {
  const [textArea, setTextArea] = useState("");
  const [loader, setLoader] = useState(false);

  const fetchingTenant = window.location.hostname.split(".")[0];
  const apiPort = process.env.REACT_APP_API_PROTOCOL;
  const getWorkshopId = localStorage.getItem(WORKSHOP_ID);
  const navigate = useNavigate();

  const cancelServiceRequest = async (e) => {
    e.preventDefault();

    // const datePart = dayjs(selectedDate).format("YYYY-MM-DD");
    // const timePart = dayjs(selectedTime).format("HH:mm:ss");
    // const preferredTime = dayjs(selectedTime).format("HH:mm");

    const bookingServicePayload = {
      status: "accepted",
      service_reply: textArea, // (optional) any note or reason for rescheduling
      user_id: getWorkshopId,
    };

    try {
      setLoader(true);
      const response = await axios.post(
        `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/gc/workshop-booking-requests/${requestedId}/update_status/`,
        bookingServicePayload
      );

      if (response?.data) {
        toast.success(response?.data?.message);
        // setIsCheckoutClicked(false)
        sessionStorage.clear();
        // refetch()
        closeModal();
        navigate("/vehicle/service-request");
        // setCartItems([])
      }
    } catch (error) {
      toast.error("An error occured");
    } finally {
      setLoader(false);
    }
  };

  const { selectedButtonBackgoundColors, selectedButtonColors } =
    useThemeColors();

  return (
    <div
      style={{
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      <div style={{ display: "flex", justifyContent: "center" }}>
        <label style={{ fontSize: "20px", fontFamily: "karbon-medium" }}>
          Confirm Appointment
        </label>
      </div>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <label style={{ fontFamily: "karbon", color: "#333" }}>Reason</label>
        <textarea
          style={{
            padding: "10px",
            borderRadius: "10px",
            fontFamily: "karbon",
          }}
          placeholder="Enter Reason Here"
          onChange={(e) => setTextArea(e.target.value)}
          value={textArea}
        />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <button
          onClick={cancelServiceRequest}
          type="submit"
          disabled={loader} // disable button while loading
          style={{
            width: "100%",
            padding: "10px 25px",
            borderRadius: "20px",
            fontFamily: "karbon",
            background: selectedButtonBackgoundColors,
            color: selectedButtonColors,
            border: "none",
            fontSize: "13px",
            cursor: loader ? "not-allowed" : "pointer", // cursor change on disable
          }}
        >
          {loader ? "Confirming..." : "Confirm Appointment"}
        </button>
      </div>
    </div>
  );
};

export default ConfirmationModal;
